import { Box, Text, styled } from '@ltvco/refresh-lib/theme';
import { ErrorOutline } from '@mui/icons-material';

interface FileUploadErrorAlertProps {
  message: string;
}

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.75),
  padding: theme.spacing(0.5, 1, 0, 1),
  color: theme.palette.error.main,
  marginTop: 10,
}));

const StyledErrorIcon = styled(ErrorOutline)({
  fontSize: 16,
});

export const FileUploadErrorAlert = ({
  message,
}: FileUploadErrorAlertProps) => (
  <Container role="alert">
    <StyledErrorIcon aria-hidden />
    <Text variant="body2" color="inherit" sx={{ whiteSpace: 'pre-line' }}>
      {message}
    </Text>
  </Container>
);
